import { ThemeProvider, Toaster } from "@caspeco/casper-ui-library";
import "./translations/config/i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app.tsx";
import ErrorBoundary from "./pages/error/error-boundary.tsx";
import rg4js from "raygun4js";
import { RAYGUN_API_KEY } from "./services/raygun/raygun-helper.ts";
import config from "./config/config.ts";
import { AppManager } from "./app-manager.tsx";
import { NavigationManager } from "./navigation-manager.tsx";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./query-client.ts";
import { PreLoginOnboarding } from "./pre-login-onboardning.tsx";
import { LoadingManager } from "./loading-manager.tsx";

rg4js("apiKey", RAYGUN_API_KEY);
rg4js("enableCrashReporting", true);
rg4js("options", {
	captureUnhandledRejections: true,
	allowInsecureSubmissions: true,
	excludedHostnames: ["localhost"],
});
const releaseTag = config.releaseTag;
if (releaseTag) {
	rg4js("setVersion", releaseTag);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<ThemeProvider>
			<Toaster />
			<ErrorBoundary wrapper={true}>
				<QueryClientProvider client={queryClient}>
					<LoadingManager>
						<NavigationManager>
							<AppManager>
								<PreLoginOnboarding>
									<ErrorBoundary wrapper={true}>
										<App />
									</ErrorBoundary>
								</PreLoginOnboarding>
							</AppManager>
						</NavigationManager>
					</LoadingManager>
					{/* Uncomment if you want to show devtools */}
					{/* <ReactQueryDevtools initialIsOpen={false} /> */}
				</QueryClientProvider>
			</ErrorBoundary>
		</ThemeProvider>
	</React.StrictMode>,
);
